import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import { VgAPI } from 'videogular2/core';


@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})


export class VideoComponent implements OnInit {

  
  @Input()  videoItem: any;
  api:VgAPI;

  @ViewChild('media')
  public media: ElementRef;

  //sourceUrl : any = "https://drbeen.23video.com/12732911/13433972/03ff3e7894e1afc9bf9f0e72b5c408bb/video_medium/blood-flow-velocity.mp4";
  sourceUrl : any = "";

  constructor(private sanitizer : DomSanitizer) { }

  ngOnInit() {
   // this.sourceUrl = this.sanitizer.bypassSecurityTrustUrl(this.getSourceUrl());
   this.sourceUrl = this.getSourceUrlMobile();
  // this.nextVideo();
  }

  ngOnChanges() {
   // this.sourceUrl = this.sanitizer.bypassSecurityTrustUrl(this.getSourceUrl());
     this.sourceUrl = this.getSourceUrlMobile();
   this.media.nativeElement.src = this.sourceUrl;
    this.media.nativeElement.load();
    this.media.nativeElement.play();
   // console.log(this.sourceUrl)
    //this.nextVideo();
    //window.location.reload();
  }

  getSourceUrlMobile(){
    let sourceUrl = '';
   if(this.videoItem.locales){
      const sourceMedia = this.videoItem.locales[0];
    return "https://drbeen.23video.com/" + sourceMedia.referenceLocationId + "/" + sourceMedia.referenceId + "/" + sourceMedia.authToken + "/video_medium/" + this.videoItem.slug + ".mp4";  
    }else{
      return sourceUrl;
    }
    return sourceUrl;
    
  }

  getSourceUrl() {
    console.log(JSON.stringify(this.videoItem));
    let sourceUrl = '';
    const sourceMedia = this.videoItem.locales[0];
    switch (sourceMedia.source) {
      case '23video':
        sourceUrl = `//media.drbeen.com/v.ihtml/player.html?token=${sourceMedia.referenceToken}&photo%5fid=${sourceMedia.referenceId}&source=embed`;
        break;
      default:
        sourceUrl = `//media.drbeen.com/v.ihtml/player.html?token=${sourceMedia.referenceToken}&photo%5fid=${sourceMedia.referenceId}&source=embed`;
    }
 //   console.log(sourceUrl);
    return sourceUrl;
  }


  onPlayerReady(api:VgAPI) {
    console.log("Player Ready Called");
    this.api = api;
    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(
      this.playVideo.bind(this)
   );
   this.api.getDefaultMedia().subscriptions.ended.subscribe(
      this.nextVideo.bind(this)
   );

}


playVideo(){
  this.api.play();
}

nextVideo(){
  this.sourceUrl = this.getSourceUrlMobile();
}



}
